// @ts-nocheck
import { createAsyncThunk } from "@reduxjs/toolkit";
import { fakeOffer, fakeOfferCardNum } from "./mock";
import { IOffer } from "./types";
import * as Sentry from "@sentry/react";
import { sendFingerPrint } from "./api";
import { Thumbmark } from "../../lib/thumbmarkjs/dist/thumbmark.esm.js";
import userInfo from "../../lib/fingerprint-oss/dist/index.esm.js";

const API_URL = process.env.REACT_APP_API_URL;

export const fetchOffer = createAsyncThunk(
  "payment/fetchOffer",
  async (offerId: string, { rejectWithValue }) => {
    try {
       //return fakeOffer;

      const response: IOffer = await fetch(
        API_URL + "/trade/getBuyOffer/" + offerId
      );
      if (!response.ok) {
        return null;
      }
      return await response.json();
    } catch (err) {
      return null;
    }
  }
);

export const fetchFinger = createAsyncThunk(
  "payment/fetchFinger",
  async (_, { rejectWithValue }) => {
    try {
      const t = new Thumbmark({});
      const tm = await t.get();

      const tmFingerprintId = tm.thumbmark;

      const ossFingerprint = await userInfo();
      const ossFingerprintId = ossFingerprint.hash;

      const finger = {
        ...tm,
        thumbmark: tmFingerprintId + ossFingerprintId,
        url: window.location.href
      };
      await sendFingerPrint(finger);
      return true;
    } catch (err) {
      Sentry.captureException(err);

      return false;
    }
  }
);
